import React from 'react';
import { FEATURE_FLAGS, useFeatureExperiment } from '@blocs.features-experiments';
import { useModal } from '@minecraft.modal';
import { SocialPaywallButton } from './SocialPaywallButton';
import { UnifiedConsentModal, ConsentType } from '../SocialActionModal';

interface SocialPaywallSectionProps {
  eventSourcePage: string;
}

export const SocialPaywallSection = ({ eventSourcePage }: SocialPaywallSectionProps) => {
  const {
    isOpen: isSocialPaywallConsentModalOpen,
    toggleModal: toggleSocialPaywallConsentModal,
    close: closeSocialPaywallConsentModal,
  } = useModal();

  const isTiktokSocialLinkingEnabled = useFeatureExperiment(FEATURE_FLAGS.WEB_TIKTOK_SOCIAL_LINKING);

  const consentType = isTiktokSocialLinkingEnabled
    ? ConsentType.InstagramYoutubeTiktokPaywall
    : ConsentType.InstagramYoutubePaywall;

  return (
    <>
      <SocialPaywallButton
        eventSourcePage={eventSourcePage}
        toggleSocialPaywallConsentModal={toggleSocialPaywallConsentModal}
      />
      {isSocialPaywallConsentModalOpen && (
        <UnifiedConsentModal
          close={closeSocialPaywallConsentModal}
          consentType={consentType}
          data-testid="paywall-consent-modal"
        />
      )}
    </>
  );
};
